import { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import getVersionDetails from '../../services/SearchVehicle/getVersionDetails';
import useLocalStorage from '../../hooks/useLocalStorage/useLocalStorage';

function getDateFormat(date, format) {
  if (!date) return null;
  try {
    const res = moment(date).format(format);
    if (format === 'YYYY' && _.inRange(res, 1950, 2100)) return res;
    if (format === 'MM') return res;
    return null;
  } catch (e) {
    return null;
  }
}

const useValuation = (record, active = true) => {
  const vehicleInit = _.get(record, 'vehicle');
  const [vehicle, setVehicle] = useState(vehicleInit);
  const [isLoading, setisLoading] = useState(false);
  const versionId = _.get(vehicle, 'versionId', null);
  const mileage = _.get(vehicle, 'mileage', null);
  const registrationDate = _.get(vehicle, 'registrationDate.date', null);
  const yearMec = getDateFormat(registrationDate, 'YYYY');
  const monthMec = getDateFormat(registrationDate, 'MM');

  // local storage to avoid multiple calls - 1 per day max
  const keyLocalStorage =
    mileage && versionId && yearMec && monthMec
      ? `${moment().format('YYYYMMDD')}.${mileage}.${versionId}.${yearMec}.${monthMec}`
      : 'quotation.fail';
  const [valuation, setValuation] = useLocalStorage(keyLocalStorage, {});

  useEffect(() => {
    if (!active) return;
    let isMounted = false;
    if (versionId && yearMec && monthMec && mileage) {
      setisLoading(true);
      getVersionDetails(versionId, yearMec, monthMec, mileage, 'marketAnalyse')
        .then((quotation) => {
          if (isMounted) return;
          setValuation(quotation);
          setisLoading(false);
        })
        .catch((e) => {
          console.log('error getting quotation', e);
          if (!isMounted) setisLoading(false);
        });
    }
    return () => {
      isMounted = true;
    };
  }, [mileage, versionId, yearMec]);

  const updateVehicle = (veh) => {
    setVehicle((v) => ({ ...v, ...veh }));
  };

  return { valuation, isLoading, updateVehicle };
};

export default useValuation;
